import React, { useEffect, useState } from 'react';
import Navbar from './components/sections/Navbar';
import Hero from './components/sections/Hero';
import LatencyRace from './components/sections/LatencyRace';
import Demo from './components/sections/Demo';
import Features from './components/sections/Features';
import Architecture from './components/sections/Architecture';
import DevelopmentStory from './components/sections/DevelopmentStory';
import WhyAstra from './components/sections/WhyAstra';
import TrustSecurity from './components/sections/TrustSecurity';
import RegulatoryCompliance from './components/sections/RegulatoryCompliance';
import FAQ from './components/sections/FAQ';
import Resources from './components/sections/Resources';
import PlatformSupport from './components/sections/PlatformSupport';
import About from './components/sections/About';
import Contact from './components/sections/Contact';
import Footer from './components/sections/Footer';
import AnimatedBackground from './components/ui/AnimatedBackground';
import SmoothScroll from './components/ui/SmoothScroll';
import CursorGlow from './components/ui/CursorGlow';
import SectionDivider from './components/ui/SectionDivider';

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect mobile devices to disable cursor glow
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024 || 'ontouchstart' in window);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <SmoothScroll>
      <div className="min-h-screen bg-background bg-noise">
        {/* Cursor glow effect - desktop only */}
        {!isMobile && <CursorGlow />}

        {/* Global interactive particle background */}
        <AnimatedBackground interactive={true} density="normal" />

        {/* Premium gradient mesh background (Stripe-style) */}
        <div className="fixed inset-0 gradient-mesh pointer-events-none" style={{ zIndex: 0 }} />

        {/* Background effects with GPU acceleration */}
        <div className="fixed inset-0 bg-grid pointer-events-none gpu-accelerated" style={{ zIndex: 1 }} />
        <div className="fixed top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl pointer-events-none animate-morph" style={{ zIndex: 1 }} />
        <div className="fixed top-1/3 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl pointer-events-none animate-morph" style={{ zIndex: 1, animationDelay: '-2s' }} />
        <div className="fixed bottom-0 left-1/2 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl pointer-events-none animate-morph" style={{ zIndex: 1, animationDelay: '-4s' }} />

        {/* Content - Professional structure:
            1. Hero (Hook)
            2. LatencyRace (Proof - includes stats)
            3. Demo (Show the product)
            4. Features (Complete system capabilities)
            5. Architecture (How it works)
            6. DevelopmentStory (Proprietary methodology)
            7. WhyAstra (Build vs Buy)
            8. TrustSecurity (Why trust us + Enterprise Security)
            9. RegulatoryCompliance (MiFID II, Audit Trail, Anti-Manipulation)
            10. FAQ (16 Technical Questions)
            11. Resources (Whitepapers & Documentation)
            12. Platform Support (OS & Cloud Compatibility)
            13. About (Technology & Credentials)
            14. Contact
            15. Footer
        */}
        <div className="relative" style={{ zIndex: 2 }}>
          <Navbar />
          <main id="main-content">
          <Hero />
          <SectionDivider variant="glow" />
          <LatencyRace />
          <SectionDivider variant="gradient" />
          <Demo />
          <SectionDivider variant="gradient" />
          <Features />
          <SectionDivider variant="glow" />
          <Architecture />
          <SectionDivider variant="gradient" />
          <DevelopmentStory />
          <SectionDivider variant="glow" />
          <WhyAstra />
          <SectionDivider variant="gradient" />
          <TrustSecurity />
          <SectionDivider variant="glow" />
          <RegulatoryCompliance />
          <SectionDivider variant="gradient" />
          <FAQ />
          <SectionDivider variant="gradient" />
          <Resources />
          <SectionDivider variant="glow" />
          <PlatformSupport />
          <SectionDivider variant="gradient" />
          <About />
          <SectionDivider variant="gradient" />
          <Contact />
          </main>
          <Footer />
        </div>
      </div>
    </SmoothScroll>
  );
}

export default App;
